import { render, staticRenderFns } from "./CountryNameTable.vue?vue&type=template&id=8ad8a79a&"
import script from "./CountryNameTable.vue?vue&type=script&lang=js&"
export * from "./CountryNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports